// Mock data for Tecniche Perfette website

export const siteInfo = {
  name: "Tecniche Perfette",
  tagline: "Freestyle Battle",
  edition: "EDIZIONE 2026 – SINCE 2003",
  djName: "DJ DOUBLE S MASTAFIVE",
  description: "Il torneo Nazionale di improvvisazione in rima - Freestyle. Nato nel 2003. Ideato da Mastafive, DJ & produttore, membro del gruppo Hip Hop 'GateKeepaz' & DJ Double S, DJ affiliato alla crew dal 1997.",
  phone: "011 0448209",
  email: "info@tecnicheperfette.com",
  hours: "DALLE 9 ALLE 18",
  instagram: "https://www.instagram.com/tecnicheperfette/",
  tiktok: "https://www.tiktok.com/@tecnicheperfette",
  spotify: "https://open.spotify.com/artist/tecnicheperfette",
  heroImage: "https://static.wixstatic.com/media/e93d0f_a52901fa9d2b445c8b9fb6c67275b154f000.jpg/v1/fill/w_1280,h_667,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/e93d0f_a52901fa9d2b445c8b9fb6c67275b154f000.jpg",
  eventCard1: "https://static.wixstatic.com/media/e93d0f_8c39d4880f994b85af528f6363c939ed~mv2.jpg/v1/fill/w_571,h_319,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20Neutral%20Modern%20Rap%20Culture%20Presentation.jpg",
  eventCard2: "https://static.wixstatic.com/media/e93d0f_122c5cc35cf2410f9a7d40240e915ef7~mv2.jpg/v1/fill/w_571,h_319,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/tecniche%20perfette%202026%20(Video).jpg",
  regolamentoImage: "https://static.wixstatic.com/media/e93d0f_22fab982f7d84186bc2cf8578b26d50d~mv2.png/v1/fill/w_403,h_93,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/REGOLAMENTO.png",
  contestFormImage: "https://static.wixstatic.com/media/e93d0f_6f9d8af07b094f73b32cff2212ec85bd~mv2.jpg/v1/fill/w_403,h_403,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/1.jpg"
};

export const navLinks = [
  { name: "HOME", path: "/" },
  { name: "CONTATTI", path: "/contatti" },
  { name: "Progetti", path: "/progetti" },
  { name: "Glossario", path: "/glossario" },
  { name: "BIOGRAFIE", path: "/biografie" },
  { name: "ALTRI FORMAT", path: "/altri-format" },
  { name: "Spotify PLAYLIST", path: "/spotify" },
  { name: "SHOP", path: "/shop" },
  { name: "Wall OF FAME", path: "/gallery" }
];

export const sponsors = [
  { name: "Cypha Kingz", logo: "https://static.wixstatic.com/media/e93d0f_1bddf26e60504a26b46fdd6d6aa26d05~mv2.png/v1/crop/x_0,y_428,w_1080,h_863/fill/w_108,h_87,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/cypha%20kingz%2021%20luglio%20bassano.png", url: "#" },
  { name: "The Dome", logo: "https://static.wixstatic.com/media/e93d0f_bbb196fc7e5c447898f328ef32ba06af~mv2.png/v1/fill/w_100,h_98,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/the%20dome%20nuovo.png", url: "https://www.instagram.com/thedomemag/" },
  { name: "Dreki Agency", logo: "https://static.wixstatic.com/media/e93d0f_79685694af7147bbbcf20e6a05c37b6c~mv2.png/v1/fill/w_93,h_80,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/1673521299995.png", url: "https://www.instagram.com/drekiagency/" },
  { name: "Hip Hop Era Foundation", logo: "https://static.wixstatic.com/media/e93d0f_3fa57c173425479f834941a0c9c0d927~mv2.png/v1/fill/w_113,h_80,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/HHF%20Logo%201.png", url: "https://www.instagram.com/hiphoperafoundation/" },
  { name: "HHCEI", logo: "https://static.wixstatic.com/media/e93d0f_410347e2be5a4c2ca9438c7e52e62e02~mv2.png/v1/fill/w_202,h_198,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/LOGO%20HHCEI%20(2).png", url: "#" },
  { name: "Believe", logo: "https://static.wixstatic.com/media/e93d0f_79d4293fdb5e46c5ad4cc52ce4afcdd9~mv2.png/v1/fill/w_77,h_14,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo_Believe_DarkBlue_edited.png", url: "#" },
  { name: "BM Records", logo: "https://static.wixstatic.com/media/e93d0f_bf4e1539136c4827bb7e2ec1d325f62f~mv2.png/v1/fill/w_83,h_42,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/logo-bm.png", url: "http://www.bmrecords.eu/" }
];

export const locations = [
  "Milano",
  "Roma",
  "Torino",
  "Napoli",
  "Bologna",
  "Firenze",
  "Genova",
  "Palermo",
  "Bari",
  "Catania",
  "Verona",
  "Padova",
  "Brescia",
  "Bergamo"
];

export const glossaryTerms = [
  { term: "Freestyle", definition: "Improvvisazione rap in tempo reale, senza testi scritti in precedenza. L'MC crea rime sul momento seguendo il beat." },
  { term: "Battle", definition: "Sfida diretta tra due MC che si affrontano a colpi di rime improvvisate, giudicati da una giuria o dal pubblico." },
  { term: "MC", definition: "Master of Ceremonies - il rapper, colui che prende il microfono e intrattiene il pubblico con le sue rime." },
  { term: "Beat", definition: "La base musicale su cui il freestyler rappa. Prodotta dal DJ o beatmaker." },
  { term: "Flow", definition: "Il ritmo e la cadenza con cui un MC rappa. Un buon flow è fluido e si adatta perfettamente al beat." },
  { term: "Punchline", definition: "Una rima particolarmente incisiva, divertente o offensiva che colpisce l'avversario durante una battle." },
  { term: "Bar", definition: "Una singola linea o verso di una rima rap. '16 bars' indica un verso standard di 16 righe." },
  { term: "Cypher", definition: "Cerchio di rapper che si alternano al microfono, improvvisando uno dopo l'altro." },
  { term: "Beatbox", definition: "L'arte di creare suoni e ritmi musicali usando solo la bocca, le labbra e la voce." },
  { term: "Scratch", definition: "Tecnica DJ che consiste nel muovere avanti e indietro il vinile sul piatto per creare suoni ritmici." },
  { term: "Drop", definition: "Il momento in cui il beat cambia intensità, spesso usato dal freestyler per enfatizzare una punchline." },
  { term: "Acapella", definition: "Rappare senza accompagnamento musicale, solo con la voce." },
  { term: "Hook", definition: "Il ritornello di una canzone rap, la parte più orecchiabile e memorabile." },
  { term: "Spit", definition: "Termine gergale per 'rappare'. 'Spittare barre' significa rappare versi." },
  { term: "Turntablism", definition: "L'arte di manipolare i suoni e creare musica usando giradischi e mixer da DJ." }
];

export const biographies = [
  {
    id: 1,
    name: "Mastafive",
    nickname: "DJ Double S",
    role: "Fondatore & DJ",
    bio: "Ideatore di Tecniche Perfette, DJ & produttore, membro del gruppo Hip Hop 'GateKeepaz'. Il nome del torneo è tratto dal singolo del 1998 'TecnichePerfette'.",
    image: "https://static.wixstatic.com/media/e93d0f_6f9d8af07b094f73b32cff2212ec85bd~mv2.jpg/v1/fill/w_300,h_300,al_c,q_80,enc_avif,quality_auto/1.jpg",
    social: { instagram: "#", tiktok: "#" }
  },
  {
    id: 2,
    name: "MC Thunder",
    nickname: "Il Tuono",
    role: "Campione 2025",
    bio: "Vincitore dell'edizione 2025 di Tecniche Perfette. Conosciuto per il suo flow aggressivo e le punchline devastanti.",
    image: null,
    social: { instagram: "#", tiktok: "#" }
  },
  {
    id: 3,
    name: "Lady Rhyme",
    nickname: "La Regina",
    role: "MC / Giudice",
    bio: "Una delle poche donne nel panorama freestyle italiano. Giudice nelle ultime 3 edizioni del torneo.",
    image: null,
    social: { instagram: "#", tiktok: "#" }
  },
  {
    id: 4,
    name: "DJ Scratch Master",
    nickname: "Scratch",
    role: "DJ Resident",
    bio: "DJ resident di Tecniche Perfette dal 2015. Specializzato in turntablism e scratch.",
    image: null,
    social: { instagram: "#", tiktok: "#" }
  }
];

export const projects = [
  {
    id: 1,
    title: "Tecniche Perfette 2026",
    description: "La nuova edizione del torneo nazionale di freestyle. Tappe in tutta Italia con le migliori battle mai viste.",
    image: "https://static.wixstatic.com/media/e93d0f_122c5cc35cf2410f9a7d40240e915ef7~mv2.jpg/v1/fill/w_571,h_319,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/tecniche%20perfette%202026%20(Video).jpg",
    status: "In corso"
  },
  {
    id: 2,
    title: "Cypha Kingz",
    description: "Evento collaterale di cypher freestyle in collaborazione con i migliori MC della scena.",
    image: "https://static.wixstatic.com/media/e93d0f_1bddf26e60504a26b46fdd6d6aa26d05~mv2.png/v1/crop/x_0,y_428,w_1080,h_863/fill/w_400,h_300,al_c,q_85,enc_avif,quality_auto/cypha%20kingz%2021%20luglio%20bassano.png",
    status: "Prossimamente"
  },
  {
    id: 3,
    title: "Hip Hop Culture Education",
    description: "Progetto educativo per portare la cultura Hip Hop nelle scuole e nei centri giovanili.",
    image: "https://static.wixstatic.com/media/e93d0f_410347e2be5a4c2ca9438c7e52e62e02~mv2.png/v1/fill/w_400,h_400,al_c,q_85,enc_avif,quality_auto/LOGO%20HHCEI%20(2).png",
    status: "Attivo"
  }
];

export const altriFormat = [
  {
    id: 1,
    title: "Battle 1vs1",
    description: "Il formato classico: due MC si sfidano in round di freestyle. Il pubblico o la giuria decide il vincitore.",
    icon: "Mic"
  },
  {
    id: 2,
    title: "Battle 2vs2",
    description: "Le coppie di MC si affrontano in tag-team. Coordinazione e chimica sono fondamentali.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Cypher",
    description: "Cerchio aperto dove i rapper si alternano liberamente. Nessun vincitore, solo flow puro.",
    icon: "Circle"
  },
  {
    id: 4,
    title: "A Tema",
    description: "Battle freestyle con argomento imposto. I MC devono improvvisare restando nel tema dato.",
    icon: "BookOpen"
  },
  {
    id: 5,
    title: "Acapella Battle",
    description: "Sfida senza beat. Solo voce e talento puro. Il formato più difficile per un freestyler.",
    icon: "Music"
  },
  {
    id: 6,
    title: "Written Battle",
    description: "Sfida con testi preparati in anticipo. Permette liriche più elaborate e strutturate.",
    icon: "FileText"
  }
];

export const shopProducts = [
  {
    id: 1,
    name: "T-Shirt Tecniche Perfette 2026",
    price: 25.00,
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/isi5qj67_maglietta%2Bnera%2Bscritta%2Bbianca.webp",
    description: "T-shirt ufficiale nera con logo Tecniche Perfette bianco. 100% cotone.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    category: "Abbigliamento"
  },
  {
    id: 2,
    name: "Felpa Hoodie TP Whyte",
    price: 35.00,
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/1vvf522g_felpa%2Bmerch.webp",
    description: "Felpa con cappuccio Whyte con logo Tecniche Perfette. Comfort e stile per veri MC.",
    sizes: ["S", "M", "L", "XL"],
    category: "Abbigliamento"
  },
  {
    id: 3,
    name: "Cappellino Snapback TP",
    price: 21.50,
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/mhih5y3p_MOCKUP%20SNAPBACK%20TP.pdf.png",
    description: "Cappellino snapback con logo frontale. Taglia unica regolabile.",
    sizes: ["Unica"],
    category: "Accessori"
  },
  {
    id: 4,
    name: "Vinile Compilation TP Vol.1",
    price: 24.99,
    image: null,
    description: "Compilation in vinile con le migliori performance freestyle delle edizioni passate.",
    sizes: [],
    category: "Musica"
  },
  {
    id: 5,
    name: "Poster Evento 2026",
    price: 14.99,
    image: null,
    description: "Poster ufficiale dell'evento in formato A2, stampa di alta qualità.",
    sizes: [],
    category: "Gadget"
  },
  {
    id: 6,
    name: "Braccialetto TP Limited",
    price: 9.99,
    image: null,
    description: "Braccialetto in silicone edizione limitata con logo Tecniche Perfette.",
    sizes: ["Unica"],
    category: "Accessori"
  }
];

export const galleryImages = [
  { id: 1, src: "https://static.wixstatic.com/media/e93d0f_8c39d4880f994b85af528f6363c939ed~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,enc_avif,quality_auto/Orange%20Neutral%20Modern%20Rap%20Culture%20Presentation.jpg", caption: "Tecniche Perfette - Rap Culture", year: 2025 },
  { id: 2, src: "https://static.wixstatic.com/media/e93d0f_122c5cc35cf2410f9a7d40240e915ef7~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,enc_avif,quality_auto/tecniche%20perfette%202026%20(Video).jpg", caption: "Tecniche Perfette 2026 - Video", year: 2026 },
  { id: 3, src: "https://static.wixstatic.com/media/e93d0f_6f9d8af07b094f73b32cff2212ec85bd~mv2.jpg/v1/fill/w_600,h_600,al_c,q_80,enc_avif,quality_auto/1.jpg", caption: "Contest Freestyle", year: 2025 },
  { id: 4, src: "https://static.wixstatic.com/media/e93d0f_a52901fa9d2b445c8b9fb6c67275b154f000.jpg/v1/fill/w_600,h_400,al_c,q_80,enc_avif,quality_auto/e93d0f_a52901fa9d2b445c8b9fb6c67275b154f000.jpg", caption: "Main Event", year: 2026 }
];

export const spotifyPlaylists = [
  {
    id: 1,
    title: "Tecniche Perfette - Playlist Ufficiale",
    embedUrl: "https://open.spotify.com/embed/playlist/4Lrer2cbFL3AmZrRWqCgs0",
    description: "La playlist ufficiale di Tecniche Perfette con i migliori brani hip hop"
  },
  {
    id: 2,
    title: "This Is: Italian Hip Hop",
    embedUrl: "https://open.spotify.com/embed/playlist/37i9dQZF1E4uemK5wv5PCG",
    description: "Il meglio della scena hip hop italiana"
  },
  {
    id: 3,
    title: "This Is: Hip Hop",
    embedUrl: "https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO37znfc",
    description: "Le hit più grandi del mondo hip hop globale"
  },
  {
    id: 4,
    title: "RapCaviar",
    embedUrl: "https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO3Ft42K",
    description: "La playlist rap più seguita al mondo con i brani più hot del momento"
  }
];

export const wallOfFame = [
  { year: 2025, winner: "MC Thunder", city: "Milano" },
  { year: 2024, winner: "Verbal Assassin", city: "Roma" },
  { year: 2023, winner: "RhymeStorm", city: "Torino" },
  { year: 2022, winner: "FlowKing", city: "Napoli" },
  { year: 2021, winner: "LyricBeast", city: "Bologna" },
  { year: 2020, winner: "WordSmith", city: "Firenze" },
  { year: 2019, winner: "BeatRider", city: "Milano" },
  { year: 2018, winner: "MC Venom", city: "Roma" },
  { year: 2017, winner: "BarStorm", city: "Torino" },
  { year: 2016, winner: "PunchMaster", city: "Genova" }
];
